import { all, call, put, take, select } from 'redux-saga/effects';

import { GET_PAGE_BREAKS } from './actions';
import { SAVE_PAGE_BREAKS } from 'Reducers/dataModels';
import { notifications, GET_PAGE_BREAKS_FAIL } from 'PipeRouter';
import { getPageBreaks as vsGetPageBreaks } from 'Services/learnkit';


function* getPageBreaks() {
  yield take(GET_PAGE_BREAKS);

  logger.info('GET_PAGE_BREAKS');

  try {
    const { pageBreaks } = yield call(vsGetPageBreaks);

    const { vbid } = yield select(state => state.reader.ebook);

    if (pageBreaks.length === 0 || vbid === '9781464193729') {
      throw "no vital source page break information found";
    } else {
      yield put({ type: SAVE_PAGE_BREAKS, data: pageBreaks });

      logger.info('GET_PAGE_BREAKS_SUCCEEDED');
    }
  } catch (err) {
    logger.error('GET_PAGE_BREAKS_FAIL', { err });
    yield put(notifications(GET_PAGE_BREAKS_FAIL));
  }
}


export default getPageBreaks;
